module.exports = __webpack_public_path__ + "img/87.4.NH3-N.49c11b91.png";